import script from "./DetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailView.vue?vue&type=script&setup=true&lang=js"

import "./DetailView.vue?vue&type=style&index=0&id=42d14fde&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_mcn_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42d14fde"]])

export default __exports__